import React from 'react'

const Button = props => {
  const { children, onClick } = props
  return (
    <button
      onClick={e => onClick(e)}
      className={`px-8 py-3 sm:px-5 text-center rounded-lg bg-secondary border border-secondary text-white flex items-center
     font-semibold hover:bg-secondary-dark relative disabled:opacity-50 disabled:cursor-not-allowed relative`}
    >
      {children}
    </button>
  )
}

export default Button
